"use client";
import { createContext } from "react";
import type { User } from "@/hooks/api/use-auth";

type JWT = {
  access: string;
  refresh: string;
  user: User;
};

interface AuthContextType {
  token: string | null;
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  setUserDetails: (jwtToken: JWT) => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextType>({
  token: null,
  user: null,
  isAuthenticated: false,
  isLoading: true,
  setUserDetails: () => {},
  logout: () => {},
});
